import React from 'react';
import '../styles/legal-page.css'; // Adjust this file to reflect changes in design
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const CookiePolicy: React.FC = () => {
  return (
    <div className="legal-page-container">
      {/* Centered Dog Image */}
      <div className="centered-image-container">
        <Link to="/">
          <img
            src={`${process.env.PUBLIC_URL}/curios-dog.jpeg`}
            alt="Curious Dog"
            className="circle-dog-image" 
          />
        </Link>
      </div>

      <div className="legal-content-container">
        <div className="content">
          <h1>Cookie Policy</h1>
          <p>
            Curios.dog uses cookies to improve user experience. This policy explains what cookies we use, how we use them, and your options regarding cookie usage.
          </p>

          <h2 className="legal-section-title">1. What Are Cookies?</h2>
          <p>
            Cookies are small text files placed on your device when you visit a website. They help us remember your preferences and improve your user experience.
          </p>

          <h2 className="legal-section-title">2. How We Use Cookies</h2>
          <p>
            We use cookies to personalize content, provide social media features, and analyze our traffic. These cookies may track things such as how long you spend on the site or the pages you visit.
          </p>

          <h2 className="legal-section-title">3. Types of Cookies We Use</h2>
          <ul>
            <li><strong>Essential Cookies:</strong> These cookies are necessary for the proper functioning of our website.</li>
            <li><strong>Performance Cookies:</strong> These cookies track how you interact with our website and help us improve user experience.</li>
            <li><strong>Functional Cookies:</strong> These cookies allow our website to remember choices you make to improve your experience.</li>
            <li><strong>Advertising Cookies:</strong> These cookies are used to deliver advertisements that are relevant to your interests.</li>
          </ul>

          <h2 className="legal-section-title">4. Your Choices Regarding Cookies</h2>
          <p>
            You can choose to accept or decline cookies by adjusting your browser settings. However, if you decline cookies, certain features of the site may not function properly.
          </p>

          <h2 className="legal-section-title">5. Changes to This Policy</h2>
          <p>
            We may update this Cookie Policy from time to time. Any changes will be posted on this page, so please check back periodically.
          </p>
        </div>

        <div className="join-waitlist-container">
          <button className="join-waitlist-btn" onClick={() => window.location.href = "/join"}>
            Join The Waiting List
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CookiePolicy;
